import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment-timezone";
import LanguageDetector from "i18next-browser-languagedetector";

import { currencyValidOrDefault } from "./index";

const defaultLanguage = "pt-BR";
import pt_BR from "./pt-BR";

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
moment().tz(timezone).format();
moment.locale("pt-br");

export function initI18n() {
  i18n
    // .use(LanguageDetector) // detect user language
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      fallbackLng: defaultLanguage,
      lng: defaultLanguage,
      resources: {
        "pt-BR": pt_BR,
      },

      // have a common namespace used around the full app
      ns: ["common"],
      defaultNS: "common",

      debug: false,

      interpolation: {
        format: function (value, format, language, data) {
          if (value instanceof Date) {
            return moment.format(format);
          } else if (typeof value === "number" && data.currency) {
            return new Intl.NumberFormat(language, {
              currency: currencyValidOrDefault(data.currency),
              style: "currency",
            }).format(value);
          }

          return value;
        },
        escapeValue: false, // not needed for react as it does escape per default to prevent xss!
      },
    });
}
